function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { ErrorReporterOriginatedError } from "./ErrorReporterOriginatedError";
// Any regex here will squelch matching error messages and not report them.
var SUPPRESSED_ERROR_REGEXES = [
    // A user trying to edit / read a notebook without access isn't noteworthy.
    /Error: User doesn't have (Write|Read) access to the kernel\./,
    /Error: Permission denied/,
    // Competition acceptance error is not exceptional.
    /To see the data you need to agree to the competition rules/,
    // Do not report 429 / 404 errors.
    /\[ResponseMiddlewares.enforceOk\] response was not ok \| (429|404)/,
    // Any useful data for this error is already lost at this point.
    // We should work on fixing this issue in Roslyn or at the middle tier.
    /Unexpected token e in JSON at position [0-9]+/,
    // stackdriver-errors-js throws some internal errors that we should not log.
    // 4xxs have a chance to loop (429 -> error -> report -> 429 -> ...)
    /Error: 4[0-9]+ http response on stackdriver report.*/,
    // Poor network conditions will not be resolved immediately.
    /Error: network error on stackdriver report.*/,
    // Cross-origin errors won't have stacktrace information available.
    /Uncaught Error: A cross-origin error was thrown.*/,
    // These errors have such generic traces that they aren't actionable. This is
    // likely from transient network issues. http://screen/32Tpq3in3sBZnZz
    /TypeError: Failed to fetch/,
    // Users are trying to include embedded google maps in their notebooks.
    /Error: Geocoding Service: You must use an API key to authenticate.*/, 
];
// Default sampling rate for the error reporter is to report 10% of errors
// observed. FE errors are far larger in volume than backend errors, since some
// errors are occuring per page load. Without sampling aggressively, we end up
// creating a lot of noise on the top-level dashboard, and use up reporting
// quota too quickly, which can prevent backend errors from logging.
var DEFAULT_SAMPLE_RATE = 0.1;
/**
 * A utility for logging errors to GCP Error Reporting (formerly Stackdriver).
 *
 * If you want an error logged, its recommended to send it manually via the
 * 'report' method on this class directly. There's support to implicitly log
 * unhandled errors and rejected promises, but that occurs at a sampled rate.
 *
 * Implicitly logged errors are sampled to be kinder to infra, as GCP API quota
 * is shared across a GCP project, including server-side error reporting.
 *
 * FE errors can be viewed at go/kaggle-fe-errors.
 */ export var GcpErrorReporter = /*#__PURE__*/ function() {
    "use strict";
    function GcpErrorReporter(config) {
        _classCallCheck(this, GcpErrorReporter);
        var key = config.key, projectId = config.projectId, service = config.service, version = config.version, userId = config.userId, _sampleRate = config.sampleRate, sampleRate = _sampleRate === void 0 ? DEFAULT_SAMPLE_RATE : _sampleRate;
        this.reportUrl = "https://clouderrorreporting.googleapis.com/v1beta1/projects/" + "".concat(projectId, "/events:report?key=").concat(key);
        this.serviceContext = {
            service: service,
            version: version
        };
        this.userId = userId;
        this.sampleRate = sampleRate;
    }
    _createClass(GcpErrorReporter, [
        {
            /**
   * Reports a JS error to GCP error reporting backends. Calling this directly
   * will always send an error report regardless of filtering or error sample
   * rate.
   */ key: "report",
            value: function report(error) {
                var event = this.getReportedErrorEvent(error);
                // Sometimes stacktraces aren't available, such as cross-domain errors.
                if (!event.message) {
                    return Promise.resolve();
                }
                return this.sendReportedErrorEvent(event);
            }
        },
        {
            /** Patches console.error to report error messages. */ key: "startReportingConsoleErrorLogging",
            value: function startReportingConsoleErrorLogging() {
                var _this = this;
                var modifiedConsole = function(baseConsole) {
                    var _this1 = _this;
                    return _objectSpread({}, baseConsole, {
                        error: function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            var _baseConsole;
                            _this1.filteredReport(new Error(args.join(" ")));
                            (_baseConsole = baseConsole).error.apply(_baseConsole, _toConsumableArray(args));
                        }
                    });
                }(window.console);
                window.console = modifiedConsole;
            }
        },
        {
            key: "startReportingUncaughtErrors",
            value: function startReportingUncaughtErrors() {
                var _this = this;
                var existingHandler = window.onerror;
                window.onerror = function(message, source, lineno, colno, error) {
                    // We need to check for an error object explicitly, because it can be
                    // missing in some cases (ex: cross-origin errors).
                    if (error) {
                        _this.filteredReport(error);
                    }
                    var ref;
                    return (ref = existingHandler === null || existingHandler === void 0 ? void 0 : existingHandler(message, source, lineno, colno, error)) !== null && ref !== void 0 ? ref : false;
                };
            }
        },
        {
            key: "startReportingUnhandledPromiseRejections",
            value: function startReportingUnhandledPromiseRejections() {
                var _this = this;
                // onunhandledrejection's type definition includes its context as part of
                // the function signature, which isn't correct and confuses the compiler.
                var existingHandler = window.onunhandledrejection;
                window.onunhandledrejection = function(evt) {
                    // If rejection events were not errors, we ignore them since we don't
                    // have enough information to log them (stacktrace, etc).
                    if (_instanceof(evt.reason, Error)) {
                        _this.filteredReport(evt.reason);
                    }
                    existingHandler === null || existingHandler === void 0 ? void 0 : existingHandler(evt);
                };
            }
        },
        {
            /**
   * Similar to report, but applies filtering to reduce noise and respects
   * sample rate. Visible for testing, generally you want to call report if
   * manually reporting errors.
   */ key: "filteredReport",
            value: function filteredReport(error) {
                var shouldLogError = Math.random() < this.sampleRate;
                if (!shouldLogError) {
                    return Promise.resolve();
                }
                var message = error.message;
                // Ignore all matching squelched messages.
                if (SUPPRESSED_ERROR_REGEXES.find(function(regex) {
                    return regex.test(message);
                })) {
                    return Promise.resolve();
                }
                // Ignore bots.
                if (!window.navigator || !window.navigator.userAgent || window.navigator.userAgent.toLowerCase().includes("bot")) {
                    return Promise.resolve();
                }
                return this.report(error);
            }
        },
        {
            key: "getReportedErrorEvent",
            value: function getReportedErrorEvent(error) {
                var _stack;
                return {
                    context: {
                        user: this.userId,
                        httpRequest: {
                            userAgent: window.navigator.userAgent,
                            url: window.location.href
                        }
                    },
                    // This is well supported and should be present on all modern browsers:
                    // http://go/mdn/JavaScript/Reference/Global_Objects/Error/Stack
                    // If for some reason this isn't set properly, the request will HTTP 400.
                    message: (_stack = error.stack) !== null && _stack !== void 0 ? _stack : "Error stacktrace was unavailable",
                    serviceContext: this.serviceContext
                };
            }
        },
        {
            key: "sendReportedErrorEvent",
            value: function sendReportedErrorEvent(event) {
                return fetch(this.reportUrl, {
                    method: "post",
                    body: JSON.stringify(event),
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }).then(function(response) {
                    response.text().then(function(responseText) {
                        var succesfulStatus = response.status >= 200 && response.status < 300;
                        if (!succesfulStatus) {
                            var errorMessage = "An application error occurred when sending the error report. " + "HTTP status: ".concat(response.status, ", response: ").concat(responseText, ", ") + "report message: ".concat(event.message);
                            throw new ErrorReporterOriginatedError(errorMessage);
                        }
                    });
                }).catch(function(error) {
                    var errorMessage = "An error occurred when sending the error report: ".concat(error.message);
                    throw new ErrorReporterOriginatedError(errorMessage);
                });
            }
        }
    ]);
    return GcpErrorReporter;
}();
